import { render, staticRenderFns } from "./TravelNoteDetail.vue?vue&type=template&id=73366508&scoped=true"
import script from "./TravelNoteDetail.vue?vue&type=script&lang=js"
export * from "./TravelNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./TravelNoteDetail.vue?vue&type=style&index=0&id=73366508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73366508",
  null
  
)

export default component.exports